/**
 * js_form add required icon
 *
 */
$(function () {
    $('input:required,select:required,textarea:required').each(function () {
        $(this).parents("tr").find("th").addClass("icon-required");
    });
});


/**
 * js_zip
 *
 */
//$(function () {
//    $('#post1').jpostal({
//        click: '#btn_postcode2address',
//        postcode: [
//                '#postcode1'
//            ],
//        address: {
//            '#address1': '%3',
//            '#address2': '%4',
//            '#address3': '%5'
//        }
//    });
//});
$(function () {
    $('#post1').jpostal({
        click: '#btn_postcode2address',
        postcode: [
                '#postcode1'
            ],
        address: {
            '#address1': '%3',
            '#address2': '%4%5',
        }
    });
});


/**
 * js_form button
 *
 */
$(document).ready(function () {
    if(!$('.pg_en')[0]){
    $("#js_submit_comfirm").attr("disabled", "disabled");
    $("#agree-1").click(function () {
        if ($(this).prop("checked") == true) {
            $("#js_submit_comfirm").removeAttr("disabled");
        } else {
            $("#js_submit_comfirm").attr("disabled", "disabled");
        }
    });
    }
});

/**
 * js_validateSetting
 *
 */
$(function () {
    if ($('.js_validate')[0]) {
        if ($('.pg_en')[0]) {
            $.extend($.validator.messages, {
//                minlength: '{0}文字以上入力して下さい。',
//                maxlength: '{0}文字以下で入力して下さい。',
//                required: '必須項目です。',
//                digits: '半角数字で入力してください',
//                email: "Eメールの形式で入力して下さい。",
//                url: "URLの形式で入力して下さい。",
            });

        } else {
            $.extend($.validator.messages, {
                minlength: '{0}文字以上入力して下さい。',
                maxlength: '{0}文字以下で入力して下さい。',
                required: '必須項目です。',
                digits: '半角数字で入力してください',
                email: "Eメールの形式で入力して下さい。",
                url: "URLの形式で入力して下さい。",
            });
        }

        //独自の検証ルールを設定
        var methods = {
            //カタカナ
            katakana: function (value, element) {
                return this.optional(element) || /^[ア-ン゛゜ァ-ォャ-ョー「」、]+$/.test(value);
            },
            //ひらがな
            hiragana: function (value, element) {
                return this.optional(element) || /^[ぁ-んー　]*$/.test(value);
            },
            //            半角英数字
            //            alphanum: function (value, element) {
            //                return this.optional(element) || /^([a-zA-Z0-9]+)$/.test(value);
            //            },

            //            半角英数記号
            alphanum: function (value, element) {
                return this.optional(element) || /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/.test(value);
            },
        };

        $.each(methods, function (key) {
            $.validator.addMethod(key, this);
        });

        var rulesSetting = {
            'check[]': {
                minlength: 1,
            },
            'postcode1': {
                digits: true,
            },
            'your-tel': {
                digits: true,
            },
            'your-fax': {
                digits: true,
            },
            //            'your-lastname-ruby': {
            //                katakana: true
            //            },
            //            'your-firstname-ruby': {
            //                katakana: true
            //            },
            //            'postcode1': {
            //                digits: true,
            //                require_from_group: [4, ".addressAll"],
            //            },
            //            'address1': {
            //                require_from_group: [4, ".addressAll"],
            //            },
            //            'address2': {
            //                require_from_group: [4, ".addressAll"],
            //            },
            //            'address3': {
            //                require_from_group: [4, ".addressAll"],
            //            },
            'your-email-confirm': {
                equalTo: 'input[name=your-email]'
            }
        };

        if ($('.pg_en')[0]) {
            var messagesSetting = {
                'code': {
                    alphanum: '半角英数字を入力してください',
                },
                'check[]': {
                    required: "1個以上にチェックを入れてください",
                },
                //            'postcode1': {
                //                require_from_group: '必須項目です。',
                //            },
                //            'address1': {
                //                require_from_group: '必須項目です。',
                //            },
                //            'address2': {
                //                require_from_group: '必須項目です。',
                //            },
                //            'address3': {
                //                require_from_group: '必須項目です。',
                //            },
//                'contact-type': {
//                    required: 'お問い合わせ内容を選択してください',
//                },
                'company': {
                    required: 'Please fulfill your Company Name or Name of Reserch Institution.',
                },
                'your-lastname': {
                    required: 'Family name is not completed.',
                },
                'your-firstname': {
                    required: 'First name is not completed.',
                },
//                'your-lastname-ruby': {
//                    //                katakana: '全角カタカナでご入力ください',
//                    required: 'せいが未入力です。',
//                },
//                'your-firstname-ruby': {
//                    //                katakana: '全角カタカナでご入力ください',
//                    required: 'めいが未入力です。',
//                },
//                'postcode1': {
//                    digits: 'ハイフン無しの半角数字でご入力ください',
//                },
//                'your-tel': {
//                    required: 'tel is not completed.',
//                    digits: 'ハイフン無しの半角数字でご入力ください',
//                },
//                'your-fax': {
//                    digits: 'ハイフン無しの半角数字でご入力ください',
//                },
                'your-email': {
                    required: 'E-mail address is not completed.',
                    require_from_group: 'E-mail address is not completed.',
                },
                'your-email-confirm': {
                    required: 'E-mail address is not completed.',
                    require_from_group: 'E-mail address is not completed.',
                    equalTo: 'The email address and the verify email address do not match.'
                },
                'inquiry': {
                    required: 'Inquiry details are not fulfilled.',
                },
            };
        } else {
            var messagesSetting = {
                'code': {
                    alphanum: '半角英数字を入力してください',
                },
                'check[]': {
                    required: "1個以上にチェックを入れてください",
                },
                //            'postcode1': {
                //                require_from_group: '必須項目です。',
                //            },
                //            'address1': {
                //                require_from_group: '必須項目です。',
                //            },
                //            'address2': {
                //                require_from_group: '必須項目です。',
                //            },
                //            'address3': {
                //                require_from_group: '必須項目です。',
                //            },
                'contact-type': {
                    required: 'お問い合わせ内容を選択してください',
                },
                'company': {
                    required: '会社名or研究機関名を記載してください。',
                },
                'your-lastname': {
                    required: '姓が未入力です。',
                },
                'your-firstname': {
                    required: '名が未入力です。',
                },
                'your-lastname-ruby': {
                    //                katakana: '全角カタカナでご入力ください',
                    required: 'せいが未入力です。',
                },
                'your-firstname-ruby': {
                    //                katakana: '全角カタカナでご入力ください',
                    required: 'めいが未入力です。',
                },
                'postcode1': {
                    digits: 'ハイフン無しの半角数字でご入力ください',
                },
                'your-tel': {
                    required: '未入力です',
                    digits: 'ハイフン無しの半角数字でご入力ください',
                },
                'your-fax': {
                    digits: 'ハイフン無しの半角数字でご入力ください',
                },
                'your-email': {
                    required: 'メールアドレスが未入力です',
                    require_from_group: 'メールアドレスが未入力です',
                },
                'your-email-confirm': {
                    required: 'メールアドレスが未入力です',
                    require_from_group: 'メールアドレスが未入力です',
                    equalTo: 'メールアドレスと確認用メールアドレスが一致しません'
                },
                'inquiry': {
                    required: 'お問い合わせ内容が未入力です',
                },
            };
        }

        var groupsSetting = {
            //            nameGroup: "your-lastname your-firstname",
            //            rubyGroup: "your-lastname-ruby your-firstname-ruby",
            //            prefGroup: "postcode1 address1 address2 address3",
            //            mailGroup: "your-email your-email-confirm",
        };


        $('.formCmn').validate({
            errorElement: "span",
            rules: rulesSetting,
            messages: messagesSetting,
            groups: groupsSetting,
            errorPlacement: function (err, element) {
                //                element.closest('td').append(err);
                element.closest('.js_inputWrap').append(err);

            }
        });
        //        $('.formCmn2').validate({
        //            errorElement: "span",
        //            rules: rulesSetting,
        //            messages: messagesSetting,
        //            errorPlacement: function (err, element) {
        //                element.closest('td').append(err);
        //
        //            }
        //        });

        $('.js_katakana').each(function () {
            $(this).rules('add', {
                katakana: true,
                messages: {
                    katakana: '全角カタカナでご入力ください',
                }
            });
        });

        $('.js_hiragana').each(function () {
            $(this).rules('add', {
                hiragana: true,
                messages: {
                    hiragana: '全角ひらがなでご入力ください',
                }
            });
        });


        $('.js_alphanum').each(function () {
            $(this).rules('add', {
                alphanum: true,
                messages: {
                    alphanum: '半角英数字を入力してください',
                }
            });
        });
    }
});


/**
 * add js_delite table
 *
 */
//$(function () {
//    $('.js_countForm').each(function () {
//        if ($(this).text().indexOf('0') != -1 && $(this).parents('tr').find(".js_countAll").text().indexOf('0') != -1) {
//            $(this).parents('tr').find(".js_del").html('<button class="el_btn el_btn__ssml js_delBtn" type="button">' + '削除' + '</button>');
//            $(this).addClass("txt-attention");
//            $(this).parents('tr').find(".js_countAll").addClass("txt-attention");
//            $(this).parents('tr').find(".js_unit").addClass("txt-attention");
//        }
//    });
//});

/**
 * js_delite table
 *
 */
//$(function () {
//    $('.js_delBtn').each(function () {
//        $(this).on("click", function () {
//            var companyName = $(this).parents("tr").find(".js_companyName").text();
//            if (!confirm(companyName + "を削除してもよろしいですか？")) {
//                return false;
//            } else {
//                $(this).parents("tr").remove();
//            }
//        });
//    });
//});

/**
 * js_mail confirm
 *
 */
//function CheckEmail_1() {
//    var mail = document.getElementById("email_1").value;
//    var mailConfirm = document.getElementById("emailConfirm_1").value;
//    // パスワードの一致確認
//    if (mail != mailConfirm) {
//        document.getElementById("confirm_error").textContent = 'メールアドレスと確認用メールアドレスが一致しません'
//        return false;
//    } else {
//        document.getElementById("confirm_error").textContent = ''
//        return true;
//    }
//};


/**
 * js_radioCheck
 *
 */
//$(function () {
//    if ($(".js_radioCheck")[0]) {
//        $('input[type="radio"]').click(function () {
//            if ($('#display-1').prop('checked')) {
//                $('#display-1').parents(".bl_form_table").find("input, textarea").not('input[name="name"] ').attr('required', 'required');
//                $('#display-1').parents(".bl_form_table").find("th").not('.js_noLabel').addClass('icon-required');
//                $('#display-1').parents(".bl_form_table").find("input, textarea").not('input[type="radio"]').prop('disabled', false);
//            } else {
//                $('#display-1').prop('checked', false);
//                $('#display-1').parents(".bl_form_table").find("input, textarea").removeAttr('required');
//                $('#display-1').parents(".bl_form_table").find("input, textarea").removeAttr('aria-describedby');
//                $('#display-1').parents(".bl_form_table").find("input, textarea").removeAttr('aria-invalid');
//                $('#display-1').parents(".bl_form_table").find("input, textarea").removeClass('error');
//                $('#display-1').parents(".bl_form_table").find("input, textarea").not('input[type="radio"]').val('');
//                $('#display-1').parents(".bl_form_table").find("input, textarea").not('input[type="radio"]').prop('disabled', true);
//                $('#display-1').parents(".bl_form_table").find("input, textarea").not('input[type="radio"]').val('');
//                $('#display-1').parents(".bl_form_table").find("th").not('.js_noLabel').removeClass('icon-required');
//                $('#display-1').parents(".bl_form_table").find("span.error").remove();
//
//            }
//        });
//    }
//});


/**
 * js_btd check
 *
 */
//$(document).ready(function () {
//    $('.js_btd').each(function () {
//        $(this).change(function () {
//            var $year = $('#year').val();
//            var $month = $('#month').val();
//            var $date = $('#date').val();
//
//            if ($year != '' && $month != '' && $month != '') {
//                $("#your-age").removeAttr("required");
//                if ($('#btd_error span').text() != '') {
//                    $('#btd_error').find('span').remove();
//                }
//            } else {
//                $("#your-age").attr("required", "required");
//            }
//
//        });
//    });
//
//    $('#your-age').change(function () {
//        var selectVal = $(this).val();
//        var $year = $('#year');
//        var $month = $('#month');
//        var $date = $('#date');
//
//        if (selectVal != '') {
//            $year.removeAttr("required");
//            $month.removeAttr("required");
//            $date.removeAttr("required");
//
//            if ($('#btd_error span').text() != '') {
//                $('#btd_error').find('span').remove();
//            }
//        } else {
//            $year.attr("required", "required");
//            $month.attr("required", "required");
//            $date.attr("required", "required");
//        }
//    });
//
//});

/**
 * js_form input file setting
 *
 */
//$(function () {
//    $(document).on('change', '.js_form_file_input', function (e) {
//        var file = $(this).prop('files')[0];
//        var label = $(this).next();
//        if (!($(this).children(".js_form_file_fileName").length)) {
//            $(this).parent(".js_form_file").append('<span class="js_form_file_fileName"></span>');
//            label.addClass('changed');
//        }
//        label.next().html(file.name);
//        if ($(this).parents("tr").find(".error")) {
//            $(this).parents("tr").find(".error").css('display', 'none');
//        }
//    });
//    $(".js_form_file_input").hover(function () {
//        $(this).next("label").addClass("fileopacity");
//    }, function () {
//        $(this).next("label").removeClass("fileopacity");
//
//    });
//});


/**
 * js_check_other 
 *
 */
//$(function () {
//    $('input[type=checkbox]').click(function () {
//        if ($('.js_check_other').prop('checked')) {
//            $('.js_check_other').parents("tr").find(".js_check_otherText").attr('required', 'required');
//
//
//        } else {
//            $('.js_check_other').prop('checked', false);
//            $('.js_check_other').parents("tr").find(".js_check_otherText").removeAttr('required');
//            $('#checkbox-text-error').remove();
//        }
//    });
//});



/**
 * js_form date
 *
 */
//$(function () {
//    var time = new Date();
//    var year = time.getFullYear();
//    var month = time.getMonth() + 1;
//    var date = time.getDate();
//
//    var selected_year = document.getElementById("year").value;
//    var selected_month = document.getElementById("month").value;
//
//    var start_year = 1900;
//    for (var i = year; i >= start_year; i--) {
//        $("#year").append('<option value="' + i + '">' + i + "</option>");
//    }
//    var last_month = 12;
//    for (var j = 1; j <= last_month; j++) {
//        $("#month").append('<option value="' + j + '">' + j + "</option>");
//    }
//
//    var last_date = 31;
//    for (var k = 1; k <= last_date; k++) {
//        $("#date").append('<option value="' + k + '">' + k + "</option>");
//    }
//
//    $("#year").change(function () {
//        selected_year = $("#year").val();
//
//        last_month = 12;
//        if (selected_year == year) {
//            last_month = month;
//        }
//        $("#month").children("option").remove();
//        $("#month").append('<option value="">--</option>');
//        for (var n = 1; n <= last_month; n++) {
//            $("#month").append('<option value="' + n + '">' + n + "</option>");
//        }
//    });
//
//    $("#year,#month").change(function () {
//        selected_year = $("#year").val();
//        selected_month = $("#month").val();
//
//        if (selected_year == year && selected_month == month) {
//            last_date = date;
//        } else {
//            if (selected_month == 2) {
//                if (
//                    (Math.floor(selected_year % 4 == 0) && Math.floor(selected_year % 100 != 0)) ||
//                    Math.floor(selected_year % 400 == 0)
//                ) {
//                    last_date = 29;
//                } else {
//                    last_date = 28;
//                }
//
//            } else if (
//                selected_month == 4 ||
//                selected_month == 6 ||
//                selected_month == 9 ||
//                selected_month == 11
//            ) {
//                last_date = 30;
//            } else {
//                last_date = 31;
//            }
//        }
//
//        $("#date").children("option").remove();
//        $("#date").append('<option value="">--</option>');
//        for (var m = 1; m <= last_date; m++) {
//            $("#date").append('<option value="' + m + '">' + m + "</option>");
//        }
//    });
//});



/**
 * js_form date calculate
 *
 */
//$("#date").change(function () {
//
//    selected_year = $("#year").val();
//    selected_month = $("#month").val();
//    selected_date = $("#date").val();
//    var yourBirthDay = {
//        year: selected_year,
//        month: selected_month,
//        date: selected_date
//    };
//    var birthDate = new Date(yourBirthDay.year, yourBirthDay.month - 1, yourBirthDay.date);
//
//    var y2 = birthDate.getFullYear().toString();
//    var y2 = ("00000" + y2).slice(-4);
//
//    var m2 = (birthDate.getMonth() + 1).toString();
//    var m2 = ("00000" + m2).slice(-2);
//
//    var d2 = birthDate.getDate().toString();
//    var d2 = ("00000" + d2).slice(-2);
//
//    var today = new Date();
//
//    var y1 = today.getFullYear().toString();
//    var y1 = ("00000" + y1).slice(-4);
//
//
//    var m1 = (today.getMonth() + 1).toString();
//    var m1 = ("00000" + m1).slice(-2);
//
//    var d1 = today.getDate().toString();
//    var d1 = ("00000" + d1).slice(-2);
//    var age = Math.floor((Number(y1 + m1 + d1) - Number(y2 + m2 + d2)) / 10000);
//
//    $('#birthDay').text(age + '歳');
//});
